export const DELAYS = {
  ONE_SECOND: 1000,
};
